"use client";

import React from "react";

import { iconColor } from "../colors";
import { createSVGIcon } from "../createSVGIcon";
import { iconCls } from "../tracking";

/**
 * @trackcomponent
 * @optimized using svgo:^3.3.4
 */
export const BSRCalendar = createSVGIcon(
  <path
    d="M2.75 5.25V4.5H2v.75zm18.5 0H22V4.5h-.75zm0 16V22H22v-.75zm-18.5 0H2V22h.75zm15-18.5a.75.75 0 0 0-1.5 0h1.5m-1.5 4.5a.75.75 0 0 0 1.5 0h-1.5m-10 0a.75.75 0 0 0 1.5 0h-1.5m1.5-4.5a.75.75 0 0 0-1.5 0h1.5m-5 2.5V6h18.5V4.5H2.75zm18.5 0h-.75v16H22v-16zm0 16v-.75H2.75V22h18.5zm-18.5 0h.75v-16H2v16zm.125-11V11h18.25V9.5H2.875zM17 2.75h-.75v4.5h1.5v-4.5zM7 7.25h.75v-4.5h-1.5v4.5z"
    fill="currentColor"
  />,
  "BSRCalendar",
  {
    className: iconCls(),
    color: iconColor.primary,
    fill: "none",
    viewBox: "0 0 24 24",
  } // This icon is decorative, keep titleAccess empty so it doesn't clutter the screenreader experience
);
